var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6.11L8 2.36L2 6.11V14H14V6.11ZM0 5L8 0L16 5V14C16 15.1 15.1 16 14 16H2C0.9 16 0 15.1 0 14V5ZM9 8H10C10.55 8 11 8.45 11 9C11 9.55 10.55 10 10 10H9V11C9 11.55 8.55 12 8 12C7.45 12 7 11.55 7 11V10H6C5.45 10 5 9.55 5 9C5 8.45 5.45 8 6 8H7V7C7 6.45 7.45 6 8 6C8.55 6 9 6.45 9 7V8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.b5f3ee5d1b00c52a958a6ad90f7c64bd.svg";
export { ForwardRef as ReactComponent };